module.exports = __webpack_public_path__ + "img/defaultHeadImg.4ea054e4.jpg";